<div class="painel-cte container-fluid">
  <h3>Painel CTE</h3>
  <mat-card id="filters">
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">
          <mat-form-field>
            <mat-label>Data inclusão (de):</mat-label>
            <input matInput
              autocomplete="off"
              maskDate [matDatepicker]="dataInicio"
              formControlName="dataInicio"
              required
              maskDate />
            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
            <mat-datepicker #dataInicio></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Data inclusão (até):</mat-label>
            <input matInput
              autocomplete="off"
              maskDate [matDatepicker]="dataFim"
              formControlName="dataFim"
              required
              maskDate />
            <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
            <mat-datepicker #dataFim></mat-datepicker>
          </mat-form-field>

          <app-cliente-autocomplete [form]="filterForm"
            (clienteIdOutput)="reciverFeedback($event)"></app-cliente-autocomplete>

          <mat-form-field>
            <mat-label>Produto:</mat-label>
            <mat-select formControlName="produtosFormControl" [disableControl]="!showProduto">
              <mat-option value="">Todos</mat-option>
              <mat-option *ngFor="let produto of produtos" [value]="produto.produtoID">
                {{produto.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Filial Emissão:</mat-label>
            <mat-select formControlName="filial"
              disableOptionCentering="true"
              placeholder="Filial">
                <mat-option><ngx-mat-select-search [formControl]="filialMultiFilter" placeholderLabel="Buscar..." noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                <mat-option selected value="">Todas</mat-option>
                <mat-option *ngFor="let filial of filteredFiliais | async" [value]="filial?.filialID">
                  {{filial?.descricao}}
                </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Número CTE:</mat-label>
            <input matInput
              autocomplete="off"
              somenteNumeros
              placeholder="Número CTE"
              formControlName="numeroCte" />
          </mat-form-field>

          <mat-form-field style="min-width: 400px">
            <mat-label>Chave CTE:</mat-label>
            <input matInput
              autocomplete="off"
              somenteNumeros
              placeholder="Chave CTE"
              formControlName="chaveCte" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Manifesto Embarque:</mat-label>
            <input matInput
              autocomplete="off"
              somenteNumeros
              placeholder="Manifesto Embarque"
              formControlName="manifestoEmbarque" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Status:</mat-label>
            <mat-select formControlName="status">
              <mat-option value="">Todos</mat-option>
              <mat-option *ngFor="let status of listaStatus" [value]="status.id">
                {{ status.status }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Pedido Id:</mat-label>
            <input matInput
              autocomplete="off"
              somenteNumeros
              placeholder="Pedido Id"
              formControlName="pedidoid" />
          </mat-form-field>

          <button mat-icon-button type="button" (click)="limparFiltros()" matTooltip="Limpar Campos">
            <i class="fas fa-eraser eraser-button"></i>
          </button>

          <button mat-icon-button
            type="submit"
            matTooltip="Pesquisar"
            (click)="listarCtes(true)"
            [disabled]="filterForm.invalid">
              <i class="fas fa-search search-button cursor-pointer-icon"></i>
          </button>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-tab-group mat-align-tabs="start"
      [selectedIndex]="detalhesCteSelected.value"
      (selectedIndexChange)="detalhesCteSelected.setValue($event)"
      [class]="detalhesCte.length > 0 ? 'with-details' : ''"
    >
      <mat-tab label="Listagem CTE">
        <div class="tab-Cte">
          <mat-card-content class="no-padding">
            <div [hidden]="isLoading || !listaCtes?.length">
              <div>
                <table id="relatorios"
                  mat-table
                  [dataSource]="listaCtes"
                  class="table-sm">

                  <ng-container matColumnDef="detalhe">
                    <th mat-header-cell *matHeaderCellDef>Detalhe</th>
                    <td mat-cell *matCellDef="let element">
                      <button mat-icon-button (click)="adicionarTabCteDetalhe(element)">
                        <i class="fas fa-info-circle"></i>
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="filial">
                    <th mat-header-cell *matHeaderCellDef>Filial</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.filialNome }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="clienteNome">
                    <th mat-header-cell *matHeaderCellDef>Cliente</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.clienteNome }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="produtoDescricao">
                    <th mat-header-cell *matHeaderCellDef>Produto</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.produtoDescricao }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="dataInclusao">
                    <th mat-header-cell *matHeaderCellDef>Data Inclusão</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.dataInclusao | date: 'dd/MM/yyyy' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="me">
                    <th mat-header-cell *matHeaderCellDef>Manifesto Embarque</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.me }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="qtdPedidos">
                    <th mat-header-cell *matHeaderCellDef>Quantidade Pedido</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.qtdPedidos }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="numCTe">
                    <th mat-header-cell *matHeaderCellDef>Número CTE</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.numCTe }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="chaveCTe">
                    <th mat-header-cell *matHeaderCellDef>Chave Cte</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.chaveCTe }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.status }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </div>
              <app-paginacao [pageIndex]="paging?.index"
                [pageSize]="paging?.size"
                [length]="paging?.length"
                (page)="onPageChange($event)"
                [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
            </div>
            <div *ngIf="!isLoading && listaCtes?.length === 0"
              class="d-flex justify-content-center align-items-center"
              style="height: 100px">
                Nenhum resultado encontrado!
            </div>
          </mat-card-content>
        </div>
      </mat-tab>

      <mat-tab *ngFor="let cte of detalhesCte; let index = index" [label]="">
        <ng-template mat-tab-label>
          ID {{cte.identificacaoId}}
          <i class="fas fa-times"
            [matTooltip]="'Fechar aba ' + cte.identificacaoId"
            (click)="removerTab(index, $event)"></i>
        </ng-template>
        <app-painel-cte-detalhe
          [objetoCTe]="cte"
          (removerTab)="removerTab(index, $event)"
          ></app-painel-cte-detalhe>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
